import { createContext, FC, useContext } from 'react';

interface IRtmpContext {
  isRtmpStream: boolean;
}

const RtmpContext = createContext<IRtmpContext | undefined>(undefined);

export const RtmpProvider: FC<{
  streamType: StreamType;
}> = props => (
  <RtmpContext.Provider
    value={{
      isRtmpStream: props.streamType === 'RTMP_STREAM',
    }}
  >
    {props.children}
  </RtmpContext.Provider>
);

export const useRtmpContext = () => {
  const context = useContext(RtmpContext);
  if (context === undefined) {
    throw new Error('useRtmpContext must be within RtmpProvider');
  }

  return context;
};
